import type { SelectType } from '../../components/shared/select/Select.type.ts';

const prepareObjectForSmartSelect = (values: object) => {
  const smartSelectValues: SelectType[] = [];

  Object.entries(values).forEach(([, value]) => {
    smartSelectValues.push({ value: value, label: value });
  });

  return smartSelectValues;
};

export { prepareObjectForSmartSelect };
